export default __webpack_public_path__ + "static/media/Aura-Egg__25.074fcbaf.png";